import {
  FETCH_SUB_MENU,
  FETCH_SUB_MENU_SUCCESS
} from "./actionTypes"


export const fetchSubMenu = (param) => {
  return {
    type: FETCH_SUB_MENU,
    payload: { 'theme_mode': param },
  }
}

export const fetchSubMenuSuccess = (response) => {
  return {
    type: FETCH_SUB_MENU_SUCCESS,
    payload: response,
  }
}